import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from './start/login-form/login-form.component';
import { PwForgottenComponent } from './start/pw-forgotten/pw-forgotten.component';
import { PwSetnewComponent } from './start/pw-setnew/pw-setnew.component';
import { ConfirmEmailComponent } from './start/confirm-email/confirm-email.component';
import { TwoFactorauthComponent } from './start/two-factorauth/two-factorauth.component';
import { PrivacyComponent } from './view/privacy/privacy.component';
import { ImprintComponent } from './view/imprint/imprint.component';
import { AllcomponentsComponent } from './view/allcomponents/allcomponents.component';
import { TermsComponent } from './view/terms/terms.component';
import { HomeComponent } from './home/home.component';
import { AuthGuardService } from './service/auth.guard.service';
import { UseraccountComponent } from './home/useraccount/useraccount.component';
import { FaqComponent } from './view/faq/faq.component';
import { TagsComponent } from './home/tags/tags.component';
import { CategoriesComponent } from './home/categories/categories.component';
import { StreamsComponent } from './home/streams/streams.component';
import { EditStreamComponent } from './home/streams/edit-stream/edit-stream.component';
import { BasicIdeaComponent } from './home/streams/stepcomponents/basic-idea/basic-idea.component';
import { UserTinderComponent } from './home/streams/stepcomponents/user-tinder/user-tinder.component';
import { IdeaTowerComponent } from './home/streams/stepcomponents/idea-tower/idea-tower.component';
import { ProblemShadowingComponent } from './home/streams/stepcomponents/problem-shadowing/problem-shadowing.component';
import { StepcomponentsComponent } from './home/streams/stepcomponents/stepcomponents.component';
import { StreamReportComponent } from './home/stream-report/stream-report.component';
import { FlyingAgentsComponent } from './home/flying-agents/flying-agents.component';
import { UserComponent } from './home/user/user.component';
import { CompaniesComponent } from './home/companies/companies.component';
import { GenericStreamViewComponent } from './home/streams/new-tracks/generic-stream-view/generic-stream-view.component';
import { UserReportComponent } from './home/user-report/user-report.component';
import { ConversationsComponent } from './home/conversations/conversations.component';
import { ConversationViewComponent } from './home/conversations/conversation-view/conversation-view.component';
import { FigmaExportsComponent } from './home/figma-exports/figma-exports.component';
import { GdprComponent } from './home/gdpr/gdpr.component';
import { StreamSummaryComponent } from './home/user-report/stream-summary/stream-summary.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'login',
        children: [
            { path: '', component: LoginFormComponent },
            { path: 'resetpassword', component: PwForgottenComponent },
            { path: ':id', component: LoginFormComponent },
            { path: 'set-new-password/:resetid', component: PwSetnewComponent },
            { path: 'confirm/:confirmid', component: ConfirmEmailComponent },
            { path: 'verify/:verifyId', component: TwoFactorauthComponent }
        ],
    },
    {
        path: 'home',
        canActivate: [AuthGuardService],
        component: HomeComponent,
        children: [
            {
                path: 'account', canActivate: [AuthGuardService], component: UseraccountComponent
            },
            {
                path: 'flying-agents', canActivate: [AuthGuardService], component: FlyingAgentsComponent
            },
            {
                path: 'tags', canActivate: [AuthGuardService], component: TagsComponent
            },
            {
                path: 'categories', canActivate: [AuthGuardService], component: CategoriesComponent
            },
            {
                path: 'streams', canActivate: [AuthGuardService], component: StreamsComponent
            },
            {
                path: 'stream-report', canActivate: [AuthGuardService], component: StreamReportComponent
            },
            {
                path: 'figma-exports', canActivate: [AuthGuardService], component: FigmaExportsComponent
            },
            {
                path: 'streams/:streamId', canActivate: [AuthGuardService], component: EditStreamComponent
            },
            {
                path: 'generic-streams/:id', canActivate: [AuthGuardService], component: GenericStreamViewComponent
            },
            {
                path: 'user', canActivate: [AuthGuardService], component: UserComponent
            },
            {
                path: 'companies', canActivate: [AuthGuardService], component: CompaniesComponent
            },
            {
                path: 'user-report', canActivate: [AuthGuardService], component: StreamSummaryComponent
            },
            {
                path: 'conversations', canActivate: [AuthGuardService], component: ConversationsComponent
            },
            {
                path: 'gdpr', canActivate: [AuthGuardService], component: GdprComponent
            },
            {
                path: 'conversations/:streamId', canActivate: [AuthGuardService], component: ConversationViewComponent
            }
        ],
    },
    {
        path: 'test-steps',
        canActivate: [AuthGuardService],
        component: StepcomponentsComponent
        , children: [
            {
                path: 'basic-idea', canActivate: [AuthGuardService], component: BasicIdeaComponent
            },
            {
                path: 'user-tinder', canActivate: [AuthGuardService], component: UserTinderComponent
            },
            {
                path: 'idea-tower', canActivate: [AuthGuardService], component: IdeaTowerComponent
            },
            {
                path: 'problem-shadowing', canActivate: [AuthGuardService], component: ProblemShadowingComponent
            }
        ]
    },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'imprint', component: ImprintComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'faq', component: FaqComponent },
    // All Components 4 you :-)
    { path: 'ac4u', component: AllcomponentsComponent },
    // Fallback
    { path: '**', redirectTo: 'home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
